import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	emblaCarouselViewport: {
		overflow: "hidden"
	},
	carouselContainer: {
		display: "flex",
		touchAction: "pan-y pinch-zoom",
		cursor: "grab",
		position: "relative",
		width: "100%"
	}
})

export default useStyles
